import React from "react";
import { Modal, Button, Row, ConfigProvider, Image } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import ic_profile_learner_attendance from '../assets/images/svgs/ic_profile_learner_attendance.svg';
import moment from 'moment'
import 'moment/dist/locale/id'

import {
  textTitleHome,
  checkCircleIcon,
  colorTextTitleMobile,
  colorTextDesc,
} from "../config/constant/color/index";


// for translate
import { useTranslation } from "react-i18next";

const dateModuleConvert = (data, localeDate = 'id') => {
  if (!data) return '-';

  const m = moment(data);

  if (!m.isValid()) return '-';

  return m
    .locale(localeDate)
    .format('DD MMMM YYYY, HH:mm');
};

const ModalSuccess = ({
  statusCheckin,
  setUseridCheckin,
  setUserFullnameCheckin,
  setSucUserFullname,
  setSucUserDateCheckin,
  setStatusCheckin,
  sucUserFullname,
  sucUserDateCheckin
}) => {
  const { t, i18n } = useTranslation();
  
  const localeDate = i18n.language === 'en' ? 'en' : 'id';
  const formattedUserDateCheckin = dateModuleConvert(sucUserDateCheckin, localeDate);

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: "16px",
            borderRadiusSM: "16px",
            borderRadiusXS: "16px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
      <Modal
        className="modal-success-admission"
        open={statusCheckin === "success" ? true : false}
        maskClosable="false"
        closeIcon={false}
        width={424}
        transitionName="ant-fade"
        keyboard
        centered
        footer={null}
      >
        <div
          style={{
            textAlign: "center",
            padding: "32px",
          }}
        >
          <CheckCircleFilled
            style={{
              color: checkCircleIcon,
              fontSize: "60px",
              marginBottom: "20px",
            }}
          />
          <div
            style={{
              fontSize: 22,
              color: textTitleHome,
              lineHeight: "normal",
              fontWeight: "500",
            }}
          >
            {t("feature.feature_scanner.checkin_success")}
          </div>

          <Row style={{ color: textTitleHome, display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
            <div style={{ fontSize: 22, marginTop: 12, lineHeight: "normal", fontWeight: "500" }}>
              {sucUserFullname}
            </div>
            <div style={{ fontSize: 14, color: "#666666", marginTop: 12, lineHeight: "normal" }}>
              {formattedUserDateCheckin}
            </div>
          </Row>

          <Button
            className="btn btn-sm btn-primary btn-block"
            style={{
              borderRadius: "6px",
              border: "none",
              fontWeight: "500",
              marginTop: "30px",
              height: "48px",
            }}
            name="btn-ok-change-password"
            onClick={() => {
              setUseridCheckin(undefined)
              setUserFullnameCheckin(undefined)
              setSucUserFullname(undefined)
              setSucUserDateCheckin(undefined)
              setStatusCheckin(undefined)
            }}
          >
            OK
          </Button>
        </div>
      </Modal>
    </ConfigProvider>
  )
}

export default ModalSuccess;